import { useSetCouponCookie } from '../useSetCouponCookie';
import { useSetPromotion } from '../useSetPromotion';

import type { PromotionContextTreatment } from './compareShadow';

interface PromotionCaptureProps {
  treatment: PromotionContextTreatment;
}

export function PromotionCapture({
  treatment,
}: PromotionCaptureProps): React.JSX.Element {
  switch (treatment) {
    // Both paths run in parallel: legacy owns cookie writes so observable
    // behavior is unchanged; context hydrates for shadow comparison.
    case 'off-with-shadowing':
      return (
        <>
          <LegacyCapture />
          <ContextCapture skipCookieWrites />
        </>
      );
    case 'on-with-shadowing':
    case 'on':
      return <ContextCapture />;
    case 'off':
    default:
      // Default covers unknown values (`control` before the flag is configured) treat as `off`
      return <LegacyCapture />;
  }
}

interface ContextCaptureProps {
  skipCookieWrites?: boolean;
}

function ContextCapture({
  skipCookieWrites = false,
}: ContextCaptureProps): null {
  useSetPromotion({ skipCookieWrites });
  return null;
}

function LegacyCapture(): null {
  useSetCouponCookie();
  return null;
}
